import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
import classnames from "classnames";
import React from "react";

import { SHORT_VIEWPORT_QUERY, WIDE_VIEWPORT_QUERY } from "../../../theme";

interface IMapControls {
  children: any;
  className?: string;
  isLegendVisible?: boolean;
}

const useStyles = makeStyles<any, Pick<IMapControls, "isLegendVisible">>(
  (theme) => ({
    root: {
      position: "absolute",
      bottom: theme.spacing(4),
      right: theme.spacing(2),
      zIndex: 999,
      display: "flex",
      alignItems: "flex-end",
      [theme.breakpoints.down("sm")]: {
        bottom: ({ isLegendVisible }) =>
          isLegendVisible ? theme.spacing(11) : theme.spacing(3),
        right: theme.spacing(1),
      },
      [`@media ${SHORT_VIEWPORT_QUERY} and ${WIDE_VIEWPORT_QUERY}`]: {
        bottom: theme.spacing(3),
      },
    },
  })
);

const MapControls = (props: IMapControls) => {
  const { className, children, isLegendVisible = false } = props;
  const classes = useStyles({ isLegendVisible });
  const classNames = classnames(classes.root, "marapp-qa-mapcontrols", {
    [className]: !!className,
  });

  return (
    <Box className={classNames}>
      {React.Children.map(
        children,
        (c, i) =>
          React.isValidElement(c) && (
            <Box key={i} pl={1}>
              {React.cloneElement(c)}
            </Box>
          )
      )}
    </Box>
  );
};

export default MapControls;
